/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ShopifyHealthcheckOffender
 */
export interface ShopifyHealthcheckOffender {
  /**
   *
   * @type {string}
   * @memberof ShopifyHealthcheckOffender
   */
  label?: string;
  /**
   *
   * @type {string}
   * @memberof ShopifyHealthcheckOffender
   */
  numericId?: string | null;
}

/**
 * Check if a given object implements the ShopifyHealthcheckOffender interface.
 */
export function instanceOfShopifyHealthcheckOffender(
  value: object,
): value is ShopifyHealthcheckOffender {
  return true;
}

export function ShopifyHealthcheckOffenderFromJSON(
  json: any,
): ShopifyHealthcheckOffender {
  return ShopifyHealthcheckOffenderFromJSONTyped(json, false);
}

export function ShopifyHealthcheckOffenderFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ShopifyHealthcheckOffender {
  if (json == null) {
    return json;
  }
  return {
    label: json["label"] == null ? undefined : json["label"],
    numericId: json["numericId"] == null ? undefined : json["numericId"],
  };
}

export function ShopifyHealthcheckOffenderToJSON(
  json: any,
): ShopifyHealthcheckOffender {
  return ShopifyHealthcheckOffenderToJSONTyped(json, false);
}

export function ShopifyHealthcheckOffenderToJSONTyped(
  value?: ShopifyHealthcheckOffender | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    label: value["label"],
    numericId: value["numericId"],
  };
}
